import styled from "styled-components";

import { breakpoints } from "@otta/design-tokens";

const FlexDiv = styled.div`
  flex-wrap: wrap;
  display: flex;
  gap: 1rem;
`;

const Assets = styled.div`
  flex-wrap: wrap;
  display: flex;
  flex-grow: 1;
  gap: 1rem;
`;

const Picture = styled.picture`
  display: flex;
  flex: 1 1 0;
`;

const Image = styled.img`
  object-fit: cover;
  flex: 1 1 0;
`;

const Content = styled.div`
  margin-bottom: 1rem;
  flex-basis: 65%;
  flex-grow: 1;
`;

/**
 * Wraps some content and adds assets around it such that
 * a portrait picture will usually go beside the content
 * but landscape pictures / multiple pictures etc go after
 */
export function AssetSprinkler({
  "data-testid": testId,
  children,
  assets,
}: React.PropsWithChildren<{
  "data-testid"?: string;
  assets?: {
    desktop: string | null;
    mobile: string | null;
    alt: string | null;
    source: string;
  }[];
}>): React.ReactElement {
  if (!assets?.length) {
    return <div data-testid={testId}>{children}</div>;
  }
  return (
    <FlexDiv data-testid={testId}>
      <Content>{children}</Content>
      <Assets>
        {assets.map(ba => (
          <Picture>
            <source
              media={`(min-width: ${breakpoints.desktop}px)`}
              srcSet={ba.desktop ?? undefined}
            />
            <Image
              src={ba.source}
              srcSet={ba.mobile ?? undefined}
              alt={ba.alt ?? undefined}
            />
          </Picture>
        ))}
      </Assets>
    </FlexDiv>
  );
}
